export const apiName: string = 'categorias-cnh';

export const categoriasCnhQuery: any = {
    "where":{
        "ativo":true,
        "categoria":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"categoria"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cnh/categorias-cnh/shared/data.service.ts
 **/